import {
    ChartShapeInfoConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-shape-info-converter';
import {
    ChartLayoutConverter,
} from '@src/slide/domain/ui-model/converter/node-property/module-property/chart/common/chart-layout-converter';
import type { ICTLegend, ICTLegendEntry, DeltaOf } from '@tencent/slide-sdk-model';
import type {
    IChartLegend,
    ILegendEntry,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type { DeepPartial, DeepReadonly } from 'ts-essentials';
import type { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export class ChartLegendConverter {
    public static convertPartialDataSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTLegend>>,
        uiData: IChartLegend,
    ) {
        // 图例默认文本属性、图形样式
        ChartShapeInfoConverter.convertPartialDataFromSdkToUi(sdkData, uiData as IShapeModel);

        // 是否覆盖在图表上
        if (sdkData.overlay !== undefined) {
            uiData.overlay = sdkData.overlay.val;
        }

        // 图例位置
        if (sdkData.legendPos !== undefined) {
            uiData.position = sdkData.legendPos.val;
        }

        // 图例布局
        if (sdkData.layout !== undefined) {
            uiData.layout = uiData.layout || {};
            ChartLayoutConverter.convertPartialDataFromSdkToUi(sdkData.layout, uiData.layout);
        } else {
            delete uiData.layout;
        }

        // 图例项独立配置
        if (sdkData.legendEntry !== undefined) {
            uiData.legendEntryList = sdkData.legendEntry.map((sdkEntry: ICTLegendEntry) => {
                const uiLegendEntry: ILegendEntry = {};

                if (sdkEntry.idx !== undefined) {
                    uiLegendEntry.id = sdkEntry.idx.val;
                }
                if (sdkEntry.deleteKeyword !== undefined) {
                    uiLegendEntry.delete = sdkEntry.deleteKeyword.val;
                }

                // 图例默认文本属性
                if (sdkEntry.txPr) {
                    ChartShapeInfoConverter.convertTxBodySdkToUi(
                        sdkEntry.txPr,
                        uiLegendEntry as unknown as IShapeModel,
                    );
                }

                return uiLegendEntry;
            });
        }
    }

    public static convertPartialDataUiToSdk(
        uiData: DeepPartial<IChartLegend>,
        sdkData: DeltaOf<ICTLegend>,
    ) {
        // 图例默认文本属性、图形样式
        ChartShapeInfoConverter.convertPartialDataFromUiToSdk(uiData as IShapeModel, sdkData);

        // 是否覆盖在图表上
        if (uiData.overlay !== undefined) {
            sdkData.overlay = { val: uiData.overlay };
        }

        // 图例位置
        if (uiData.position !== undefined) {
            if (!uiData.position) {
                sdkData.legendPos = null;
            } else {
                sdkData.legendPos = { val: uiData.position };
            }
        }

        // 图例布局
        if (uiData.layout !== undefined) {
            if (!uiData.layout) {
                sdkData.layout = null;
            } else {
                sdkData.layout = sdkData.layout ?? {};
                ChartLayoutConverter.convertPartialDataFromUiToSdk(uiData.layout, sdkData.layout);
            }
        }

        // 图例目前不支持单独选中。如果后续支持，这里需要转成op描述
        if (uiData.legendEntryList !== undefined) {
            sdkData.legendEntry = uiData.legendEntryList.map((uiLegendItem) => {
                const sdkLegendItem: ICTLegendEntry = {};
                if (uiLegendItem?.id !== undefined) {
                    sdkLegendItem.idx = { val: uiLegendItem.id };
                }
                if (uiLegendItem?.delete !== undefined) {
                    sdkLegendItem.deleteKeyword = { val: uiLegendItem.delete };
                }
                if (uiLegendItem?.paragraphList !== undefined) {
                    sdkLegendItem.txPr = sdkLegendItem.txPr ?? {};
                    ChartShapeInfoConverter.convertTxBodyUiToSdk(
                        uiLegendItem as unknown as IShapeModel,
                        sdkLegendItem.txPr,
                    );
                }

                return sdkLegendItem;
            });
        }
    }
}
